"use client";

import dynamic from "next/dynamic";
import type { SubtitleTrack, UserVideo } from "@/lib/types";
import { getEmbedPreferredLanguage } from "./embedPreferredLanguage";

/**
 * Embed route is a Server Component that must not eagerly import `Player.tsx`:
 * that module pulls `firebaseConfig` → `getAuth()` at load time, which throws on
 * the Node server when `NEXT_PUBLIC_FIREBASE_*` is missing/invalid (RSC 500).
 * `ssr: false` keeps the heavy client stack (Firebase Web SDK, Vidstack, Hls, mux)
 * off the server render path while still receiving `video` props from the server.
 */
const EmbedPlayer = dynamic(() => import("./EmbedPlayer").then(m => m.default), {
  ssr: false,
  loading: () => null
});
export function EmbedPlayerLoader({
  video,
  subtitleTracks
}: {
  video: UserVideo;
  subtitleTracks?: SubtitleTrack[];
}) {
  const preferredLanguage = typeof window !== "undefined" ? getEmbedPreferredLanguage(window.location.search) : undefined;
  return <EmbedPlayer video={video} subtitleTracks={subtitleTracks} preferredLanguage={preferredLanguage} data-sentry-element="EmbedPlayer" data-sentry-component="EmbedPlayerLoader" data-sentry-source-file="EmbedPlayerLoader.tsx" />;
}